import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FileExportService } from 'src/app/common/file-export-service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DropDownValues, MRPService } from '../../mrp/mrp.service';
import { ExportData, FilterInput, FilterMappingService, FiltersOutput } from 'src/app/models/filter-objects';
import { TaskDataFilter } from '../../stock/stock.service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { OrderOverviewPram } from 'src/app/models/mrp/mrp-overview-moels';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { DxDataGridComponent } from 'devextreme-angular';
import { NotificationService } from 'src/app/services/notification.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
import * as FileSaver from 'file-saver';
import { UtilsService } from 'src/app/services/utils.service';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { firstValueFrom } from 'rxjs';
import { Data } from '@angular/router';
import { FiltersGroupBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/filters-group-bookmark-elements.operator';
import { QueryFilterParameter } from 'src/app/widgets/filters/models/query-filter-parameter.model';

@Component({
	selector: 'app-overview',
	templateUrl: './order-optimizer-overview.component.html',
	styleUrls: ['./order-optimizer-overview.component.scss'],
	standalone: false
})
export class OrderOptimizerOverviewComponent implements OnInit {

	filterOptions: FiltersOutput;
	taskFilterData: TaskDataFilter[];

	IsTaskLoad = false;
	//bookmark
	dataFilter: BookmarkData;
	pageName: string = "MRPOrderOptimizerOverview";
	htmlControlType = HtmlControlType;
	resetFiltersItems: string[] = [];
	currentlySelectedFilters: FilterInput[] = [];

	settingGroupId = 133;

	//Filter state
	gridFilterStateOrder: any;
	gridFilterStateOrderLine: any;
	headerFiltersStateOrder: any = {};
	headerFiltersStateOrderLine: any = {};
	filterRowStateOrder: {};
	filterRowStateOrderLine: {};
	OrderDataGridLine: any;

	constructor(
		private mrpService: MRPService,
		private titleService: Title,
		private shareDataService: ShareDataService,
		private fileExportService: FileExportService,
		private tableParamService: TableParameterService,
		private _activatedRoute: ActivatedRoute,
		private notificationService: NotificationService
	) { }

	public pageFiltersOperator: FiltersOperator = new FiltersOperator(
		new SelectStatementOptions(
			{
				filters: async () => this.pageFiltersOperator.appliedFilters,

				baseSelectStatementId: BaseSelectStatementId.DEV_GetOrderOptimizerOverView,
				selectionSetId: SelectionSetId.OrderOptimizerOverView,
			}
		)
	);


	async ngOnInit() {
		this.isStop = false;
		this.titleService.setTitle("Order Optimizer - Overview");
		this.checkExeFirst();
		this.checkingRunning();
		this.loadAllListData();

		this.mrpService.OrderOptimizerSettings().subscribe(resp => {
			console.log("OrderOptimizerSettings", resp);
			if (resp != null && resp.length > 0) {
				resp[0].forEach(element => {
					if (element.Name == "ToggleCollapseExpandOrder") {
						if (element.Value.toLowerCase().trim() == "yes") {
							this.OrderSettng.ToggleCollapseExpandOrder = true;
						} else { this.OrderSettng.ToggleCollapseExpandOrder = false; }
					}

					if (element.Name == "ToggleCollapseExpandOrderLine") {
						if (element.Value.toLowerCase().trim() == "yes") {
							this.OrderSettng.ToggleCollapseExpandOrderLine = true;
						} else { this.OrderSettng.ToggleCollapseExpandOrderLine = false; }
					}


					if (element.Name == "ToggleTitleOrder" && element.Value != null) {
						this.OrderSettng.ToggleTitleOrder = element.Value;
					}

					if (element.Name == "ToggleTitleOrderLine" && element.Value != null) {
						this.OrderSettng.ToggleTitleOrderLine = element.Value;
					}
				});
			}
		});

		this.pageFiltersOperator.onFiltersApplied.subscribe(
			(selection) => {
				this.shareDataService.CleanData();
				this.shareDataService.filterOptionOverview = this.pageFiltersOperator.overviewFiltersOutput;

				this.pageFiltersOperator.load();
				this.getData('reload');
			}
		);

		await this.initializeBookmarks();

		this.loadPageData();
	}

	@ViewChild('bookmarksGroup', { static: true })
	public bookmarksGroup: BookmarkNewComponent;

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		this.bookmarkElementsOperators = [
			new FiltersGroupBookmarkElementsOperator(
				{
					id: UtilsService.computeRouteHash(routeData.id, FiltersGroupBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
					filtersOperator: () => this.pageFiltersOperator
				}
			),
		];

		return routeData;
	}

	public async loadPageData(): Promise<void> {
		(await this.pageFiltersOperator.getObservable(
			{
				showLoadingIndicator: true,
			}
		)).subscribe(
			{
				next: async (response) => {

					if (!(await this.bookmarksGroup.applyDefaultBookmark())) {
						this.getData('reload');
					}
				}
			}
		);
	}

	OrderSettng = { ToggleCollapseExpandOrderLine: false, ToggleCollapseExpandOrder: false, ToggleTitleOrder: "", ToggleTitleOrderLine: "" };
	checkExeFirst() {
		let $this = this;
		let interval = setInterval(function () {
			$this.checkingRunning();
			if ($this.isStop) {
				clearInterval(interval);
			}
		}, 15000);
	}

	lastSelectedFilter: FilterInput;


	fileDownloadDataOrders: FilePathCollection = new FilePathCollection();
	fileDownloadDataOrder: FilePathCollection = new FilePathCollection();
	filterMappingService = new FilterMappingService();
	exportToExcel() {
		// new export code
		let newData = new ExportData();
		newData.fromPeriod = '';
		newData.toPeriod = '';
		newData.isAgg = 0;
		newData.filters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.pageFiltersOperator.overviewFiltersOutput.filters);
		newData.fileType = 'xlsx';

		this.exportOrders(newData);
		this.exportOrder(newData);
	}

	exportOrders(newData: ExportData) {
		newData.type = 'OrderOptimizerOverviewOrders';
		newData.title = 'Order Optimizer Overview Orders';
		newData.filename = 'order-optimizer-overview-orders';
		this.fileExportService.ExportToFile(newData, { showLoadingIndicator: true, loadingIndicatorLoggingEnabled: false, errorLoggingEnabled: false }).subscribe(resultFilename1 => {
			this.fileDownloadDataOrders.FileName = resultFilename1.fieldName;
			this.fileDownloadDataOrders.LinkType = 1;
			this.fileExportService.DownloadFile(this.fileDownloadDataOrders).subscribe(result => {
				const blob = new Blob([result], { type: EXCEL_TYPE });
				FileSaver.saveAs(blob, this.fileDownloadDataOrders.FileName);
			}, error => console.error('Error downloading the file', error),
				() => console.info('File downloaded successfully'));

		}, err => {
			console.log("Get Export Data Service Error", err);
		});
	}

	exportOrder(newData: ExportData) {
		newData.type = 'OrderOptimizerOverviewOrder';
		newData.title = 'Order Optimizer Overview Order';
		newData.filename = 'order-optimizer-overview-order';
		this.fileExportService.ExportToFile(newData, { showLoadingIndicator: true, loadingIndicatorLoggingEnabled: false, errorLoggingEnabled: false }).subscribe(resultFilename1 => {
			this.fileDownloadDataOrder.FileName = resultFilename1.fieldName;
			this.fileDownloadDataOrder.LinkType = 1;
			this.fileExportService.DownloadFile(this.fileDownloadDataOrder).subscribe(result => {
				const blob = new Blob([result], { type: EXCEL_TYPE });
				FileSaver.saveAs(blob, this.fileDownloadDataOrder.FileName);
			}, error => console.error('Error downloading the file', error),
				() => console.info('File downloaded successfully'));

		}, err => {
			console.log("Get Export Data Service Error", err);
		});
	}

	dataSourceMainList: any[] = [];
	dataSourceSubList: any[] = [];
	tableColumnsSourceMainList: any[] = [];
	tableColumnsSubList: any[] = [];
	getData(action) {

		let dataObjectPram: OrderOverviewPram = new OrderOverviewPram();
		dataObjectPram.Action = action;
		dataObjectPram.filtersOptions = [];

		this.pageFiltersOperator.overviewFiltersOutput.filters.forEach(element => {
			let filterItem: QueryFilterParameter = new QueryFilterParameter(
				element.fieldName,
				element.value,
				element.operation
			);
			dataObjectPram.filtersOptions.push(filterItem);
		});

		this.mrpService.GetOrderOptimizerOverView(dataObjectPram).subscribe(resp => {
			if (resp) {
				this.dataSourceMainList = resp[0];
				this.dataSourceSubList = resp[1];
				this.tableColumnsSourceMainList = resp[2];
				this.tableColumnsSubList = resp[3];
				this.reapplyGridStates();
			}

		});
	}

	tableHeight = 700;
	switchTableHeight() {
		this.tableHeight = this.tableParamService.changeTableHeigh(this.tableHeight);
	}

	tableHeightOrderLine = 700;
	switchTableHeightOrderLine() {
		this.tableHeightOrderLine = this.tableParamService.changeTableHeigh(this.tableHeightOrderLine);
	}

	fitTableToPage = false;
	fitTableToPageOrderLine = false;

	anyActiveFilters = false;
	@ViewChild('editingOrderDataGrid', { static: false }) OrderDataGrid: DxDataGridComponent;
	@ViewChild('editingOrderDataLineGrid', { static: false }) OrderDataLinGrid: DxDataGridComponent;


	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.OrderDataGrid.instance.clearFilter();
			this.gridFilterStateOrder = null;
			this.headerFiltersStateOrder = {};
			this.filterRowStateOrder = {};
		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}
		if (this.filterRowStateOrder) {
			Object.keys(this.filterRowStateOrder).forEach(field => {
				const filter = this.filterRowStateOrder[field];
				evt.component.columnOption(field, {
					filterValue: filter.filterValue
				});
			});
		}

		if (this.headerFiltersStateOrder && Object.keys(this.headerFiltersStateOrder).length > 0) {
			Object.keys(this.headerFiltersStateOrder).forEach(field => {
				const filterValues = this.headerFiltersStateOrder[field];
				if (filterValues && filterValues.length > 0) {
					evt.component.columnOption(field, {
						filterValues: [...filterValues]
					});
				}
			});
		}

		this.dxDataGridOperator.updateRowCount(evt.component);
		localStorage.setItem('grid-state-order-optimizer-overview', JSON.stringify(this.OrderDataGrid.instance.state()));
	}
	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'SaveAndExecuteButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		});
	}

	onToolbarPreparingOrderLine(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'SaveAndExecuteButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		});
	}

	changesFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;
		let currentState = this.OrderDataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.OrderDataGrid.instance.state(currentState);
	}

	changesFitToPageOrderLineStatus() {
		this.fitTableToPageOrderLine = !this.fitTableToPageOrderLine;
		let currentState = this.OrderDataLinGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.OrderDataLinGrid.instance.state(currentState);
	}



	isVisbleOrderOptimzer(item: any) {
		if (item != null && item.column != null && item.column.allowEditing != null && item.column.allowEditing) {
			return item.column.allowEditing;
		}
		return false;
	}

	onRowPrepared(e: any): void {
		e.rowElement.style.height = "50px";
	}

	async saveData() {

		await this.waitOneSecond();
		let OrderSaveData = { ParentData: "", Action: "" };
		OrderSaveData.Action = "Order";
		let lcChangedOrderMainTableRecords = JSON.parse(JSON.stringify(this.changedOrderMainTableRecords));
		lcChangedOrderMainTableRecords.forEach(orderItem => {
			this.tableColumnsSourceMainList.forEach(item => {
				if (item != null && item.IsEditable && orderItem != null) {
					orderItem[item.FieldName] = this.ConvertDataType(item.DataType, orderItem[item.FieldName]);
				}
			});
		});
		OrderSaveData.ParentData = JSON.stringify(lcChangedOrderMainTableRecords);
		if (OrderSaveData.ParentData.length > 2) {

			this.mrpService.SaveMrpOrderData(OrderSaveData).subscribe(resp => {
				if (resp != null && resp[0] && resp[0][0] && resp[0][0].Flag) {
					if (resp[0][0].Flag == 1) {
						this.notificationService.success(resp[0][0].Msg);
					} else {
						this.notificationService.error(resp[0][0].Msg);
					}
					this.changedOrderMainTableRecords = [];
				}
				if (resp != null && resp[0] && resp[0][0] && resp[0][0].flag) {
					if (resp[0][0].flag == 1) {
						this.notificationService.success(resp[0][0].msg);
					} else {
						this.notificationService.error(resp[0][0].msg);
					}
					this.changedOrderMainTableRecords = [];
				}
				if (resp != null && resp[0] && resp[0] && resp[0].flag) {
					if (resp[0].flag == 1) {
						this.notificationService.success(resp[0].msg);
					} else {
						this.notificationService.error(resp[0].msg);
					}
					this.changedOrderMainTableRecords = [];
				}
				this.unsavedChanges = false;
				this.saveGridStates();
				this.getData('reload');

			}), err => {

				this.notificationService.error("Something went wrong.");
			};
		}
		else {
			this.notificationService.error("No changes found.");
		}

	}

	ConvertDataType(DataType: string, orderItem: any) {
		if (DataType != undefined && DataType != null && orderItem != undefined && DataType != orderItem) {
			if (DataType.trim().toLowerCase() == "date") {
				let newDate = new Date(orderItem);
				return this.formatDateToDDMMYYYY(newDate);
			}
			if (DataType.trim().toLowerCase() == "number") {
				if (!Number.isNaN(parseFloat(orderItem))) {
					return parseFloat(orderItem);
				}
			}
		}
		return orderItem;
	}

	formatDateToDDMMYYYY(date: Date): string {
		const day = date.getDate().toString().padStart(2, '0');
		const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Note: Months are zero-based
		const year = date.getFullYear();
		return `${year}${month}${day}`;
	}

	unsavedChanges = false;
	gridOrderDataRowUpdated(e) {
		this.unsavedChanges = true;
		this.addOrReplace(e.data);
	}

	changedOrderMainTableRecords: any[] = [];
	arrIndex = {};
	addOrReplace(object) {
		if (object && object.UniqueId) {
			let index = this.arrIndex[object.UniqueId];
			if (index === undefined) {
				index = this.changedOrderMainTableRecords.length;
				this.arrIndex[object.UniqueId] = index;
			}
			this.changedOrderMainTableRecords[index] = {};
			this.changedOrderMainTableRecords[index].UniqueId = object.UniqueId;
			this.tableColumnsSourceMainList.forEach(item => {
				if (item != null && item.IsEditable) {
					this.changedOrderMainTableRecords[index][item.FieldName] = object[item.FieldName];
				}
			});
		}
	}


	unsavedChangesOrderLine = false;
	gridOrderDataRowUpdatedOrderLine(e) {
		this.unsavedChangesOrderLine = true;
		this.addOrReplaceOrderLine(e.data);
	}

	changedOrderLineTableRecords: any[] = [];
	arrIndexOrderLine = {};
	addOrReplaceOrderLine(object) {
		if (object && object.UniqueId) {
			let index = this.arrIndexOrderLine[object.UniqueId];
			if (index === undefined) {
				index = this.changedOrderLineTableRecords.length;
				this.arrIndexOrderLine[object.UniqueId] = index;
			}
			this.changedOrderLineTableRecords[index] = {};
			this.changedOrderLineTableRecords[index].UniqueId = object.UniqueId;
			this.tableColumnsSubList.forEach(item => {
				if (item != null && item.IsEditable) {
					this.changedOrderLineTableRecords[index][item.FieldName] = object[item.FieldName];
				}
			});
		}
	}

	isVisbleOrderLineOptimzer(item: any) {
		if (item != null && item.column != null && item.column.allowEditing != null && item.column.allowEditing) {
			return item.column.allowEditing;
		}
		return false;
	}

	anyOrderLineActiveFilters = false;

	changeOrderLineActiveFiltersStatus() {
		if (this.anyOrderLineActiveFilters) {
			this.anyOrderLineActiveFilters = !this.anyOrderLineActiveFilters;
			this.OrderDataLinGrid.instance.clearFilter();
			this.gridFilterStateOrderLine = null;
			this.headerFiltersStateOrderLine = {};
			this.filterRowStateOrderLine = {};
		}
	}

	onRowPreparedOrderLine(e: any): void {
		e.rowElement.style.height = "50px";
	}

	public dxDataGridOperatorOrderLine: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReadyOrderLine(evt) {
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyOrderLineActiveFilters = true;
		} else {
			this.anyOrderLineActiveFilters = false;
		}
		if (this.filterRowStateOrderLine) {
			Object.keys(this.filterRowStateOrderLine).forEach(field => {
				const filter = this.filterRowStateOrderLine[field];
				evt.component.columnOption(field, {
					filterValue: filter.filterValue
				});
			});
		}

		if (this.headerFiltersStateOrderLine && Object.keys(this.headerFiltersStateOrderLine).length > 0) {
			Object.keys(this.headerFiltersStateOrderLine).forEach(field => {
				const filterValues = this.headerFiltersStateOrderLine[field];
				if (filterValues && filterValues.length > 0) {
					evt.component.columnOption(field, {
						filterValues: [...filterValues]
					});
				}
			});
		}

		this.dxDataGridOperatorOrderLine.updateRowCount(evt.component);
		localStorage.setItem('grid-state-order-optimizer-overview-orderline', JSON.stringify(this.OrderDataLinGrid.instance.state()));
	}

	onDataGridCellPreparedOrderLine(e) {
		e.cellElement.style.padding = '5px';
	}

	saveGridStates() {
		if (this.OrderDataGrid && this.OrderDataGrid.instance) {
			this.gridFilterStateOrder = this.OrderDataGrid.instance.getCombinedFilter();
			this.filterRowStateOrder = {};
			this.headerFiltersStateOrder = {};
			this.OrderDataGrid.instance.getVisibleColumns().forEach((col: any) => {
				if (col.dataField) {
					if (col.filterValue) {
						this.filterRowStateOrder[col.dataField] = {
							filterValue: col.filterValue,
						};
					}
					if (col.filterValues && col.filterValues.length > 0) {
						this.headerFiltersStateOrder[col.dataField] = [...col.filterValues];
					}
				}
			});
		}
		if (this.OrderDataLinGrid && this.OrderDataLinGrid.instance) {
			this.gridFilterStateOrderLine = this.OrderDataLinGrid.instance.getCombinedFilter();
			this.filterRowStateOrderLine = {};
			this.headerFiltersStateOrderLine = {};
			this.OrderDataLinGrid.instance.getVisibleColumns().forEach((col: any) => {
				if (col.dataField) {
					if (col.filterValue) {
						this.filterRowStateOrderLine[col.dataField] = {
							filterValue: col.filterValue,
						};
					}
					if (col.filterValues && col.filterValues.length > 0) {
						this.headerFiltersStateOrderLine[col.dataField] = [...col.filterValues];
					}
				}
			});
		}
	}

	async saveOrderLineData() {

		await this.waitOneSecond();
		let OrderSaveData = { ParentData: "", Action: "" };
		OrderSaveData.Action = "OrderLine";
		let lcChangedOrderLineTableRecords = JSON.parse(JSON.stringify(this.changedOrderLineTableRecords));
		lcChangedOrderLineTableRecords.forEach(orderItem => {
			this.tableColumnsSubList.forEach(item => {
				if (item != null && item.IsEditable && orderItem != null) {
					orderItem[item.FieldName] = this.ConvertDataType(item.DataType, orderItem[item.FieldName]);
				}
			});
		});
		OrderSaveData.ParentData = JSON.stringify(lcChangedOrderLineTableRecords);
		if (OrderSaveData.ParentData.length > 2) {

			this.mrpService.SaveMrpOrderData(OrderSaveData).subscribe(resp => {
				if (resp != null && resp[0] && resp[0].flag) {
					if (resp[0].flag == 1) {
						this.notificationService.success(resp[0].msg);
					} else {
						this.notificationService.error(resp[0].msg);
					}
					this.changedOrderLineTableRecords = [];
				}
				else if (resp != null && resp[0] && resp[0][0] && resp[0][0].flag) {
					if (resp[0][0].flag == 1) {
						this.notificationService.success(resp[0][0].msg);
					} else {
						this.notificationService.error(resp[0][0].msg);
					}
					this.changedOrderMainTableRecords = [];
				}
				else if (resp != null && resp[0] && resp[0] && resp[0].flag) {
					if (resp[0].flag == 1) {
						this.notificationService.success(resp[0].msg);
					} else {
						this.notificationService.error(resp[0].msg);
					}
					this.changedOrderMainTableRecords = [];
				}
				else {
					this.notificationService.error("Something went wrong.");
				}
				this.unsavedChangesOrderLine = false;
				this.saveGridStates();
				this.getData('reload');

			}), err => {

				this.notificationService.error("Something went wrong.");
			};
		}
		else {
			this.notificationService.error("No changes found.");
		}
	}

	isStop = false;
	ngOnDestroy() {
		this.isStop = true;
	}

	IsRunning: boolean = false;
	checkingRunning() {
		this.mrpService.CheckRunningProcess().subscribe(resp => {
			if (resp) {
				this.IsRunning = true;
			} else { this.IsRunning = false; }
		});
	}


	exectueMrp() {
		this.IsRunning = true;
		this.mrpService.StartProcess().subscribe(resp => {
			this.IsRunning = true;
			this.checkExeFirst();
			let keys = Object.keys(resp);

			if (resp[keys[1]] != null) {
				if (resp[keys[1]] > 0) {
					this.notificationService.success(resp[keys[0]]);
				} else {
					this.notificationService.error(resp[keys[0]]);
				}
			} else {
				this.notificationService.error("Something went wrong.");
			}
		});
	}

	loadDataList(SelectionTableName: string): any {
		let items = this.SelectListForDropDown.filter(x => x.Type == SelectionTableName);
		if (SelectionTableName == "Location") {
			for (let obj of items) {
				obj.Value = obj.Value.toString();
			}
		}
		return (items ? items : []);
	}

	SelectListForDropDown: DropDownValues[] = [];
	loadAllListData() {
		this.mrpService.SelectListForDropDown().subscribe(resp => {
			this.SelectListForDropDown = resp;
		});
	}

	OrderDataRowButtonClicked(e, data) {
		e.event.stopPropagation();


		window.open('order-optimizer/deep-dive?id=' + UtilsService.getURLHelper(data.data.UniqueId), '_blank');

	}

	OrderLineDataRowButtonClicked(e, data) {
		e.event.stopPropagation();


		window.open('mrp/deepdive?id=' + UtilsService.getURLHelper(data.data.LinkId), '_blank');

	}

	public onToggleOrderDataGridClick(event: boolean) {
		this.OrderSettng.ToggleCollapseExpandOrderLine = event;
	}

	public onToggleOrderDataLineGridClick(event: boolean) {
		this.OrderSettng.ToggleCollapseExpandOrder = event;
	}

	reapplyGridStates() {
		if (this.OrderDataGrid && this.gridFilterStateOrder) {
			this.OrderDataGrid.instance.filter(this.gridFilterStateOrder);
		}
		if (this.OrderDataGridLine && this.gridFilterStateOrderLine) {
			this.OrderDataGridLine.instance.filter(this.gridFilterStateOrderLine);
		}
	}

	waitOneSecond(): Promise<void> {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve();
			}, 1000); // 1000 milliseconds = 1 second
		});
	}

	onEditorPreparing(event: any, gridIdentifier: string) {
		if (event.parentType === "dataRow" && event.dataField) {

			if (event.editorOptions) {
				const originalOnValueChanged = event.editorOptions.onValueChanged;

				event.editorOptions.onValueChanged = (args: any) => {
					this.handleValueChange(event, args.value, gridIdentifier);

					// Call original handler if present
					if (originalOnValueChanged) {
						originalOnValueChanged(args);
					}
				};
			}
		}
	}

	onEditorPrepared(event: any, gridIdentifier: string) {
		if (event.parentType === "dataRow" && event.dataField) {
				event.editorElement.addEventListener("input", (e: Event) => {
				const newValue = (e.target as HTMLInputElement).value;
				this.handleValueChange(event, newValue, gridIdentifier);
				}, 300);
		}
	}

	handleValueChange(event: any, newValue: any, gridIdentifier: string) {
		if (newValue !== event.row.data[event.dataField]) {
			if(gridIdentifier==='editingOrderDataGrid'){
				this.unsavedChanges = true;
			}
			else if (gridIdentifier === 'editingOrderDataLineGrid') {
				this.unsavedChangesOrderLine = true;
			}
			// Commit the value to the grid's data source
			event.setValue(newValue); // Required for grid to track the change
			// this.dataGrid.instance.saveEditData();
		}
	}
}
